export enum Roles {
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    MEMBER = 'MEMBER',
    VIDEO_ONLY = 'VIDEO_ONLY'
}
